/**
 * User: yd
 * Date: 2019/7/18
 * Time: 14:28
 * 申请直播
 **/
export default [
	{
		path: 'live-for/:liveId',
		component: () => import("@views/broadcast/live-for"),
		meta:{
			tabBar: false,
		},
		children: [
			{
				path: 'live-for-two',
				component: () => import("@views/broadcast/live-for/live-for-two"),
				meta:{
					tabBar: false,
				},
			},
			{
				path: 'live-for-three',
				component: () => import("@views/broadcast/live-for/live-for-three"),
				meta:{
					tabBar: false,
				},
				children: [
					{
						path: 'select-goods',
						component: () => import("@views/broadcast/live-for/select-goods"),
						meta:{
							tabBar: false,
						},
						children: [
							{
								path: 'select/:goods_id',
								component: () => import("@views/broadcast/live-for/select-goods/select"),
								meta:{
									tabBar: false,
								},
							}
						]
					},{
						path: 'select-info',
						component: () => import("@views/broadcast/live-for/select-info"),
						meta:{
							tabBar: false,
						},
					},
					{
						path: 'goods-search',
						component: () => import("@views/broadcast/live-for/search/goods-search"),
						meta:{
							tabBar: false,
						},
					},
					{
						path: 'info-search',
						component: () => import("@views/broadcast/live-for/search/info-search"),
						meta:{
							tabBar: false,
						},
					}
				]
			}
		]
	}
]